import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    activeFeature : null
}

export const updateActiveFeatureSlice = createSlice({
    name:'active-feature',
    initialState,
    reducers:{
       setActiveFeature:(state,action)=>{
        state.activeFeature = action.payload
       }
    }
})

export const {setActiveFeature} = updateActiveFeatureSlice.actions

export default updateActiveFeatureSlice.reducer